<template lang="pug">
.post-footer
  button.btn.tribute-button(
    id="tributes"
  )
    .tribute-button__display-content(
      :class="{ '--always-visible': isAuthor }"
    )
      span.tribute-button__icon ❤
      span.tribute-button__count(v-if="tributesCount > 0") {{ tributesCount }}
      span.tribute-button__text {{ tributesCount > 1 ? 'Tributes' : 'Tribute' }}

    .tribute-button__interact-content(
      v-if="!isAuthor"
    )
      span.tribute-button__icon ❤
      span.tribute-button__text {{ tributeClickText }}

</template>

<script>
import PostResourceMixin from '@/mixins/postResource'

export default {
  name: 'post-footer',
  mixins: [PostResourceMixin],
  computed: {
    tributesCount() {
      return this.tributes.length
    },
    tributeClickText() {
      return this.tributes.find(userId => userId === this.$currentUser.id)
        ? 'Retract'
        : 'Tribute'
    },
  },
}
</script>

<style lang="sass">
.post-footer
  padding: 1rem 0 4rem

  .tribute-button
    position: relative
    border-radius: 0
    float: left
  
  .tribute-button__icon
    margin-right: .5rem
  .tribute-button__count
    padding: 0 .5rem
  
  .tribute-button__interact-content
    position: absolute
    top: 0
    left: 0
    bottom: 0
    right: 0
    display: flex
    justify-content: center
    align-items: center
    opacity: 0

  .tribute-button
    &:hover,
    &:focus
      .tribute-button__display-content:not(.--always-visible)
        opacity: 0
      .tribute-button__interact-content
        opacity: 1
</style>
